import {AlertFillIcon, CopilotIcon} from '@primer/octicons-react'
import {Spinner} from '@primer/react'
import {clsx} from 'clsx'

import styles from './CopilotProgressIndicator.module.css'

const waitingMessage = 'Summarizing changes… this might take a minute'

export interface CopilotProgressIndicatorProps {
  isError?: boolean
  isLoading: boolean
}

export const CopilotProgressIndicator = (props: CopilotProgressIndicatorProps) => {
  return props.isLoading ? (
    <div className={styles.CopilotIndicatorContainer}>
      <div data-testid="copilot-summary-error-banner-icon" className={styles.CopilotSpinnerContainer}>
        <Spinner size="small" data-testid="copilot-spinner" />
      </div>
      <span className={styles.CopilotWaitingText}>{waitingMessage}</span>
    </div>
  ) : (
    <div
      data-testid="copilot-spinner"
      className={clsx(
        styles.CopilotIconContainer,
        props.isError ? styles.CopilotIconContainerError : styles.CopilotIconContainerDefault,
      )}
    >
      <CopilotIcon />
      {props.isError ? (
        <div className={styles.CopilotErrorBadge}>
          <AlertFillIcon size={12} />
        </div>
      ) : null}
    </div>
  )
}
